import { render, staticRenderFns } from "./BackButton.component.vue?vue&type=template&id=3b086257&"
import script from "./BackButton.component.vue?vue&type=script&lang=ts&"
export * from "./BackButton.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports